import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../../typings'

type Payload = {
  label: string
  sourceId: string
  credentials: uui.domain.server.gps.telematics.Credential[]
}

/**
 * Refreshes GPS Data
 *
 * @private
 */
export const addTenantSource = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/gps/telematics/addTenantSource', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/gps/telematics/addTenantSource', {
      category: 'rpc',
      payload,
      type: 'rpc/gps/telematics/addTenantSource',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(`Unknown error on {addTenantSource}`, { tags: ['rpc'] }, 'error')

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Creation of Telematics tenant source Failed`,
      error,
    })
  }
})
